import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-react';
import './DashboardItem.scss';
import { CourseProps, calculateActualDuration, courseDetailPath } from '../../common';
import { DeliveryDetails, DurationIcon, LevelIcon, CategoryIcon } from '../../components';
import { NavLink } from 'react-router-dom';
import { CourseBadges } from '../course/Badges';
import { MarkdownContent } from '../../components/MarkdownContent';
import { TelemetryEvents, TelemetryPage, TELEMETRY_EVENT_TYPES } from '../../common/TelemetryEvents';
import { useTrackUserEvent } from '../../common/telemetry';

const DashboardItemHeader = ({ item }: { item: CourseProps }) => {
    const trackUserEvent = useTrackUserEvent();
    return (
        <SpaceBetween size='xs' direction='vertical'>
            <CourseBadges item={item} />
            <div className='title-container'>
                <h2 className='title' aria-label={item.activityName ? 'Activity Name' : 'Class Title'}>
                    <NavLink
                        to={courseDetailPath(item.id)}
                        onClick={() => trackUserEvent(TELEMETRY_EVENT_TYPES.LINK_CLICK, TelemetryEvents.DASHBOARD_COURSE_TITLE_CLICK)}
                    >
                        {item.activityName ? item.activityName : item.courseDetails.name}
                    </NavLink>
                </h2>
                {item.activityName && <Box variant='strong'>{item.courseDetails.name}</Box>}
            </div>
        </SpaceBetween>
    );
};

export const createCardDefinition = () => {
    return {
        header: (item: CourseProps) => <DashboardItemHeader item={item} />,
        sections: [
            {
                id: 'metadata',
                content: (item: CourseProps) => (
                    <div className='metadata'>
                        <DurationIcon value={calculateActualDuration(item.schedule)} />
                        {item.courseDetails.skillLevel && <LevelIcon value={item.courseDetails.skillLevel} />}
                        {item.courseDetails.category && <CategoryIcon value={item.courseDetails.category} />}
                    </div>
                ),
            },
            {
                id: 'description',
                content: (item: CourseProps) => (
                    <Box>
                        <div className='description' aria-label='Description'>
                            <MarkdownContent content={item.courseDetails.description} />
                        </div>
                        <br />
                        <div className='location' aria-label='Location'>
                            <b>Location</b>: {item.location}
                        </div>
                        <br />
                        <DeliveryDetails course={item} page={TelemetryPage.DASHBOARD} />
                    </Box>
                ),
            },
        ],
    };
};
